// import React, { useEffect, useState } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import DashboardCard from 'src/components/shared/DashboardCard';
// import { Button, Grid } from '@mui/material';
// import { Box } from '@mui/system';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { useMain } from '../hooks/useMain';
// import TextInputs from 'src/components/inputs/TextInputs';
// import SelectInputs from 'src/components/inputs/SelectInputs';

// const initialValue = {
//   serviceName: '',
//   category: '',
//   duration: '',
//   price: '',
//   serviceFor: '',
// };

// const initialFormValidation = {
//   serviceNameValidation: false,
//   priceValidation: false,
//   serviceForValidation: false,
// };

// const serviceOptions = [
//   {
//     name: 'Male',
//   },
//   {
//     name: 'Female',
//   },
//   {
//     name: 'Both',
//   },
// ];

// const AddService = () => {
//   const { createService, activeBranchId, setShowMessage,  } = useMain();

//   const [formData, setFormData] = useState(initialValue);
//   const [formValidation, setFormValidation] = useState(initialFormValidation);

//   const [loading, setLoading] = useState(false);

//   const serviceNameValidation = !formData.serviceName.trim();
//   const priceValidation = !formData.price || !(Number(formData.price) > 0);
//   const serviceForValidation = !formData.serviceFor;

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = async () => {
//     const { serviceName, price, serviceFor } = formData;
//     const validation = {
//       serviceNameValidation: !serviceName.trim(),
//       priceValidation: !price || !(Number(price) > 0),
//       serviceForValidation: !serviceFor,
//     };

//     setFormValidation((pre) => ({ ...pre, ...validation }));

//     if (Object.values(validation).some((item) => item)) return;

//     try {
//       setLoading(true);
//       const res = await createService(
//         JSON.stringify({
//           ...formData,
//           branchDetails: activeBranchId,
//         }),
//       );
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Successfully created service',
//           messageType: 'success',
//         });
//         setFormData(initialValue);
//         setFormValidation((pre) => ({ ...initialFormValidation }));
//       } else {
//         setShowMessage({ message: res.message || 'Error creating service', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Error creating service', messageType: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // This logic disables the mouse wheel event
//   useEffect(() => {
//     const handleWheel = (e) => {
//       if (document.activeElement.type === 'number') {
//         document.activeElement.blur();
//       }
//     };

//     window.addEventListener('wheel', handleWheel);
//     return () => {
//       window.removeEventListener('wheel', handleWheel);
//     };
//   }, []);


//   return (
//     <PageContainer title="Add Service" description="this is add Service">
//       <DashboardCard title="Add Service">
//         <Box style={{ marginTop: '20px' }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 title={'Service Name'}
//                 name={'serviceName'}
//                 value={formData?.serviceName}
//                 handleChange={handleChange}
//                 type={'text'}
//                 placeholder={'Service Name'}
//                 fieldValidation={serviceNameValidation && formValidation.serviceNameValidation}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={true}
//                 title={'Category Name'}
//                 name={'category'}
//                 value={formData?.category}
//                 handleChange={handleChange}
//                 type={'text'}
//                 placeholder={'Category Name'}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 title={'Price'}
//                 name={'price'}
//                 placeholder="0"
//                 value={formData?.price}
//                 handleChange={handleChange}
//                 type={'number'}
//                 min={'0'}
//                 fieldValidation={priceValidation && formValidation.priceValidation}
//               />
//             </Grid>
//           </Grid>
//         </Box>

//         <Box style={{ marginTop: '20px' }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={false}
//                 title={'Duration (in minutes)'}
//                 name={'duration'}
//                 placeholder="0"
//                 value={formData?.duration}
//                 handleChange={handleChange}
//                 type={'number'}
//                 min={'0'}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <SelectInputs
//                 title={'Services For'}
//                 options={serviceOptions}
//                 name={'serviceFor'}
//                 value={formData?.serviceFor}
//                 handleChange={handleChange}
//                 optionTitle={'name'}
//                 optionValue={'name'}
//                 fieldValidation={serviceForValidation && formValidation.serviceForValidation}
//               />
//             </Grid>
//           </Grid>
//         </Box>

//         <div style={{ width: '200px', margin: '3rem auto' }}>
//           {loading ? (
//             <ShowLoader />
//           ) : (
//             <Button
//               variant="contained"
//               fullWidth
//               price="primary"
//               target="_blank"
//               sx={{
//                 background: '#6174DD',
//               }}
//               onClick={handleSubmit}
//             >
//               Add Service
//             </Button>
//           )}
//         </div>
//       </DashboardCard>
//     </PageContainer>
//   );
// };

// export default AddService;

import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Autocomplete, Button, Checkbox, Grid, InputAdornment, TextField, FormControl, Select, MenuItem, Typography } from '@mui/material';
import { Box } from '@mui/system';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';
import SelectInputs from 'src/components/inputs/SelectInputs';
import { GridSearchIcon } from '@mui/x-data-grid';
import { debounce } from 'lodash';
import { current } from '@reduxjs/toolkit';
import Suggestion from './Suggestion';

const initialValue = {
  serviceName: '',
  category: '',
  duration: '',
  price: '',
  serviceFor: '',
  taxStatus: 'noGst', // New field for Tax Status
  mappedProducts: [],
  reminderDays: null,
};

const initialFormValidation = {
  serviceNameValidation: false,
  categoryValidation: false,
  priceValidation: false,
  serviceForValidation: false,
};

const serviceOptions = [
  { name: 'Male' },
  { name: 'Female' },
  { name: 'Both' },
];

const taxStatusOptions = [
  { value: 'withTax', label: 'Inclusive (5% GST)' },
  { value: 'withoutTax', label: 'Exclusive (5% GST)' },
  // { value: 'noGst', label: 'No GST' },
];

const AddService = () => {
  const {
    createService,
    activeBranchId,
    setShowMessage,
    fetchAllConsumeProducts,
    branchData,
    getAppointmentPageData,
    fetchAllServices,
  } = useMain();

  const [formData, setFormData] = useState(initialValue);
  const [formValidation, setFormValidation] = useState(initialFormValidation);
  const [loading, setLoading] = useState(false);
  const [productData, setProductData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [productSearch, setProductSearch] = useState('');
  const [hoveredProductIndex, setHoveredProductIndex] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const serviceInputRefs = useRef(null);
  const [existingServices, setExistingServices] = useState([]);
  const [suggested, setSuggested] = useState([]);
  const [activeField, setActiveField] = useState('');

  const serviceNameValidation = !formData.serviceName.trim();
  const categoryValidation = !formData.category?.trim();
  const priceValidation = !formData.price || !(Number(formData.price) > 0);
  const serviceForValidation = !formData.serviceFor;

  const taxableValue = useMemo(() => {
    const p = Number(formData.price) || 0;
    if (formData.taxStatus === 'withTax') {
      return (p / 1.05).toFixed(2);
    }
    return p.toFixed(2);
  }, [formData.price, formData.taxStatus]);

   useEffect(()=>{
       const timer =  setTimeout(() => {
      // Check if serviceInputRefs.current exists before trying to focus
      if (serviceInputRefs.current && serviceInputRefs.current.focus) {
        serviceInputRefs.current.focus();
      }
    }, 100);
    return () => clearInterval(timer)
   },[])
  useEffect(() => {
    const branch = activeBranchId || localStorage.getItem('branchId');
    if (branch) {
      getProductData();
      getCategories();
      getExistingServices(branch);
    }
  }, [activeBranchId]);
  // Debounced search handler
  const handleSearchChange = useCallback(
    debounce((value) => {
      setProductSearch(value);
    }, 300),
    []
  );

 const getExistingServices = async (branch) => {
  try {
    const res = await fetchAllServices(branch); // remove `branch` if your hook takes no argument
    if (res?.statusCode === 200 && Array.isArray(res?.data)) {
      setExistingServices(res.data);
    }
  } catch (error) {}
};

const updateSuggested = (inputValue) => {
  if (!inputValue.trim()) {
    setSuggested([]);
    return;
  }
  const names = existingServices
    .filter((s) => s.serviceName?.toLowerCase().includes(inputValue.toLowerCase()))
    .map((s) => s.serviceName.trim());
  setSuggested([...new Set(names)].slice(0, 10));
};


const handleSuggestedClick = (name) => {
  setFormData((prev) => ({ ...prev, serviceName: name }));
  setSuggested([]);
};

const handleInputFocus = () => {
  setSuggested([]);
  const el = document.activeElement;
  setActiveField(el && el.getAttribute('name') ? el.getAttribute('name') : '');
};

  // Memoized filtered products for better performance
  const filteredProducts = useMemo(() => {
    if (!productSearch.trim()) return productData;
    return productData.filter((product) =>
      product.consumeableProductName?.toLowerCase().includes(productSearch.toLowerCase())
    );
  }, [productData, productSearch]);

  // Product selection handler
  const handleProductChange = (event, newValue) => {
    setSelectedProducts(newValue);
    setFormData(prev => ({
      ...prev,
      mappedProducts: newValue.map(product => product._id)
    }));
  };

  const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
  if (name === 'serviceName') updateSuggested(value);
};

  // Service Name: block leading spaces while typing
  const handleServiceNameChange = (e) => {
    const value = e.target.value.trimStart();
    setFormData((prev) => ({ ...prev, serviceName: value }));
    updateSuggested(value);
  };

  // Trims pasted text, then inserts it at the cursor position
  const makePasteHandler = (field) => (e) => {
    e.preventDefault();
    const { selectionStart, selectionEnd, value } = e.target;
    const pasted = e.clipboardData.getData('text').trim();
    const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
    setFormData((prev) => ({ ...prev, [field]: next }));
    if (field === 'serviceName') updateSuggested(next);
  };

  // Trims trailing spaces when the field loses focus
  const makeBlurHandler = (field) => (e) => {
    const trimmed = (e.target.value || '').trim();
    if (trimmed !== e.target.value) {
      setFormData((prev) => ({ ...prev, [field]: trimmed }));
    }
  };

  useEffect(() => {
    const branch = activeBranchId || localStorage.getItem('branchId');
    if (branch) {
      getProductData();
      getCategories();
      getExistingServices(branch);
    }
  }, [activeBranchId]);

  useEffect(() => {
  document.addEventListener('focus', handleInputFocus, true);
  return () => document.removeEventListener('focus', handleInputFocus, true);
}, [activeField]);

  // Clean up debounce
  useEffect(() => {
    return () => {
      handleSearchChange.cancel();
    };
  }, [handleSearchChange]);

  const getCategories = async () => {
    try {
      const branch = activeBranchId || localStorage.getItem('branchId');
      if (!branch) return;
      const res = await getAppointmentPageData(branch);
      if (res?.statusCode === 200 && res?.data?.services) {
        setCategories(res.data.services || []);
      } else if (res?.statusCode === 200 && Array.isArray(res?.data)) {
        setCategories(res.data || []);
      } else {
        setShowMessage({
          message: res?.message || 'Failed to fetch categories',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Error fetching categories',
        messageType: 'error',
      });
    }
  };

  const categoryOptions = useMemo(() => {
    if (!Array.isArray(categories)) return [];
    const seen = new Set();
    const result = [];
    categories.forEach((item) => {
      const name = typeof item === 'string' ? item.trim() : item?.categoryName?.trim();
      if (name && !seen.has(name.toLowerCase())) {
        seen.add(name.toLowerCase());
        result.push(name);
      }
    });
    return result;
  }, [categories]);

  const existingServiceOptions = useMemo(() => {
   const term = formData.serviceName.trim().toLowerCase();
    if (!term) return [];
    return existingServices
    .filter((s) => s.serviceName?.toLowerCase().includes(term))
    .slice(0, 20); // limit list size
  }, [existingServices, formData.serviceName]);

  const getProductData = async () => {
    try {
      setLoading(true);
      const branch = activeBranchId || localStorage.getItem('branchId');
      const res = await fetchAllConsumeProducts(branch);
      if (res.statusCode === 200) {
        setProductData(res.data);
      } else {
        setShowMessage({
          message: res.message || 'Failed to fetch Product data',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
    const fieldLabelStyle = {
    fontSize: '14px',
    fontWeight: 600,
    marginBottom: '6px',
    display: 'block',
    color: '#212529',
    minHeight: '18px',
  };

  const helperTextStyle = {
    fontSize: '12px',
    color: '#8a8f98',
    marginTop: '4px',
  };

  const inputBoxStyle = (hasError) => ({
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${hasError ? '#e53935' : '#ced4da'}`,
    borderRadius: '6px',
    height: '48px',
    transition: 'border-color 0.2s ease-in-out',
    '&:hover': { borderColor: '#6174DD' },
  });

  const plainInputStyle = {
    border: 'none',
    outline: 'none',
    flex: 1,
    padding: '0 12px',
    fontSize: '15px',
    background: 'transparent',
    width: '100%',
    height: '100%',
  };

  const handleSubmit = async () => {
    const { serviceName, category, price, serviceFor, taxStatus } = formData; // Destructure new field

    const validation = {
      serviceNameValidation: !serviceName.trim(),
      categoryValidation: !category?.trim(),
      priceValidation: !price || !(Number(price) > 0),
      serviceForValidation: !serviceFor,
            taxStatusValidation: branchData?.gstNumber ? !taxStatus : false,

    };

    setFormValidation((pre) => ({ ...pre, ...validation }));

    if (Object.values(validation).some((item) => item)) return;

    try {
      setLoading(true);
      const payload = {
        ...formData,
        taxableValue: taxableValue,
        branchDetails: activeBranchId,
      };

      if (!branchData?.gstNumber) {
        delete payload.taxStatus;
      }

      const res = await createService(JSON.stringify(payload));
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Successfully created service',
          messageType: 'success',
        });
        setFormData(initialValue);
        setSelectedProducts([]);
        setFormValidation((pre) => ({ ...initialFormValidation }));
      } else {
        setShowMessage({ message: res.message || 'Error creating service', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Error creating service', messageType: 'error' });
    } finally {
      setLoading(false);
    }
  };

  // Disable mouse wheel event for number inputs
  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur();
      }
    };

    window.addEventListener('wheel', handleWheel);
    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);

  return (
    <PageContainer title="Add Service" description="this is add Service">
      <DashboardCard title="Add Service">
        <Box style={{ marginTop: '20px' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <label style={fieldLabelStyle}>
                Service Name <span style={{ color: 'red' }}>*</span>
              </label>
              <Box sx={inputBoxStyle(serviceNameValidation && formValidation.serviceNameValidation)}>
                <input
                  ref={serviceInputRefs}
                  name="serviceName"
                  value={formData.serviceName}
                  onChange={handleServiceNameChange}
                  onPaste={makePasteHandler('serviceName')}
                  onBlur={makeBlurHandler('serviceName')}
                  type="text"
                  placeholder="e.g. Hair Cut"
                  style={plainInputStyle}
                  autoComplete="off"
                />
              </Box>
              {/* <div style={helperTextStyle}>Existing services will appear as you type.</div> */}
              {suggested.length > 0 && activeField === 'serviceName' && (
                <Suggestion data={suggested} handleSuggestedClick={handleSuggestedClick} />
              )}
            </Grid>
            <Grid item xs={12} md={4}>
              <Box>
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  component="label"
                  htmlFor="category"
                  mb="5px"
                  display="block"
                >
                  Category Name <span style={{ color: 'red' }}>*</span>
                </Typography>
                <div onBlur={makeBlurHandler('category')} onPaste={makePasteHandler('category')}>
                <Autocomplete
                  freeSolo
                  clearOnBlur={false}
                  selectOnFocus
                  handleHomeEndKeys
                  options={categoryOptions}
                  value={formData?.category || ''}
                  onChange={(event, newValue) => {
                    const val = typeof newValue === 'string' ? newValue : newValue?.categoryName || '';
                    setFormData((prev) => ({
                      ...prev,
                      category: val.trim(),
                    }));
                  }}
                  onInputChange={(event, newInputValue) => {
                    setFormData((prev) => ({
                      ...prev,
                      category: (newInputValue || '').trimStart(),
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select or enter category name"
                      error={!!(categoryValidation && formValidation.categoryValidation)}
                      helperText={
                        categoryValidation && formValidation.categoryValidation
                          ? 'Category Name is required'
                          : ''
                      }
                      fullWidth
                    />
                  )}
                  fullWidth
                />
                </div>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <label style={{
                    fontSize: "15px",
                    fontWeight: 600,
                    marginBottom: "4px",
                    display: "inline-block",
                    color: "#212529"
                  }}>Price <span style={{ color: 'red' }}>*</span></label>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      border: `1px solid ${priceValidation && formValidation.priceValidation ? 'red' : '#ced4da'}`,
                      borderRadius: '4px',
                      height: "57px",
                      transition: 'border-color 0.2s ease-in-out',
                      '&:hover': {
                        borderColor: '#6174DD',
                      },
                    }}
                  >
                    <span style={{ padding: '0px 8px', fontSize: '16px', color: '#666' }}>₹</span>
                    <input
                      name="price"
                      placeholder="0"
                      value={formData?.price}
                      onChange={handleChange}
                      type="number"
                      min="0"
                      style={{
                        border: 'none',
                        outline: 'none',
                        flex: 1,
                        padding: '12px 0px',
                        fontSize: '16px',
                        background: 'transparent',
                        width: '100%'
                      }}
                    />
                    {branchData?.gstNumber && (
                      <Select
                        name="taxStatus"
                        value={formData?.taxStatus || 'noGst'}
                        onChange={handleChange}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                        sx={{
                          background: '#F0F0F0',
                          border: 'none',
                          height: '100%',
                          borderTopLeftRadius: '0px',
                          borderBottomLeftRadius: '0px',
                          borderTopRightRadius: '3px',
                          borderBottomRightRadius: '3px',
                          '& .MuiSelect-select': {
                            padding: '8px 16px',
                            paddingRight: '24px !important',
                            height: '100% !important',
                            display: 'flex',
                            alignItems: 'center'
                          },
                          '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                          },
                          '&:hover': {
                            background: '#e0e0e0',
                          },
                          '&.Mui-focused': {
                            background: '#e0e0e0',
                          },
                          borderLeft: '1px solid #ced4da'
                        }}
                      >
                        {taxStatusOptions.map(option => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </Box>
                  {branchData?.gstNumber && (
                    <Box sx={{
                      p: '8px 12px',
                      backgroundColor: '#e9ecef',
                      border: '1px solid #ced4da',
                      borderTop: 'none',
                      borderRadius: '0 0 4px 4px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                      <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Taxable Value: {taxableValue}</span>
                    </Box>
                  )}
                </FormControl>
              </Grid>
          </Grid>
        </Box>

        <Box style={{ marginTop: '20px' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <TextInputs
                required={false}
                title={'Duration (in minutes)'}
                name={'duration'}
                placeholder="0"
                value={formData?.duration}
                handleChange={handleChange}
                type={'number'}
                min={'0'}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <SelectInputs
                title={'Services For'}
                options={serviceOptions}
                name={'serviceFor'}
                value={formData?.serviceFor}
                handleChange={handleChange}
                optionTitle={'name'}
                optionValue={'name'}
                fieldValidation={serviceForValidation && formValidation.serviceForValidation}
              />
            </Grid>
             {/* {branchData?.gstNumber && (
            <Grid item xs={12} md={4}>
             
              <TextInputs
                title={'Taxable Value'}
                name={'taxableValue'}
                value={taxableValue}
                type={'text'}
                placeholder={'0'}
                disabled={true}
                required={false}
              />
                
            </Grid>
            )}
            {branchData?.gstNumber && (
              <Grid item xs={12} md={4}>
                <SelectInputs
                  title={'Tax Status'}
                  options={taxStatusOptions} // Use the new options
                  name={'taxStatus'} // Use the new field name
                  value={formData?.taxStatus}
                  handleChange={handleChange}
                  optionTitle={'label'} // Assuming label is for display
                  optionValue={'value'} // Assuming value is for data
                  required={false}
                                    fieldValidation={formValidation.taxStatusValidation}
                />
              </Grid>
              
            )} */}
            <Grid item xs={12} md={4}>
              <div style={{ marginBottom: '5px', fontWeight: 'bold' , marginTop: '5px' }}>Select Products</div>
              <Autocomplete
                multiple
                options={filteredProducts}
                getOptionLabel={(option) => option.consumeableProductName || ''}
                value={selectedProducts}
                onChange={handleProductChange}
                onInputChange={(event, newInputValue) => {
                  handleSearchChange(newInputValue);
                }}
                disableCloseOnSelect
                renderOption={(props, option, { selected }) => {
                  const index = props.id.split('-').pop();
                  const isHovered = hoveredProductIndex === index;
                  return (
                    <li
                      {...props}
                      onMouseEnter={() => setHoveredProductIndex(index)}
                      onMouseLeave={() => setHoveredProductIndex(null)}
                      style={{
                        backgroundColor: isHovered ? '#6174DD' : 'white',
                        color: isHovered ? 'white' : 'black',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '6px 12px',
                      }}
                    >
                      <Checkbox
                        checked={selected}
                        sx={{
                          color: isHovered ? 'white' : 'default',
                          '&.Mui-checked': { color: isHovered ? 'white' : '#1976d2' },
                        }}
                      />
                      {option.consumeableProductName} ({option.productVolume} {option.productUnit})
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={
                      selectedProducts.length > 0
                        ? `${selectedProducts.length} products selected`
                        : 'Search products...'
                    }
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <GridSearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                fullWidth
              />
            </Grid>
                     <Grid item xs={12} md={4}>
              <TextInputs
                required={true}
                title={'Reminder Days'}
                name={'reminderDays'}
                placeholder="0"
                value={formData?.reminderDays}
                handleChange={handleChange}
                type={'number'}
                min={'0'}
              />
            </Grid>
          </Grid>
        </Box>

        <div style={{ width: '200px', margin: '3rem auto' }}>
          {loading ? (
            <ShowLoader />
          ) : (
            <Button
              variant="contained"
              fullWidth
              sx={{
                background: '#6174DD',
              }}
              onClick={handleSubmit}
            >
              Add Service
            </Button>
          )}
        </div>
      </DashboardCard>
    </PageContainer>
  );
};

export default AddService;